import { ReceiptDetailPanelVariant } from "./shared/ReceiptDetailPanelVariant";
import ecoSign from "./images/ecoSign.png";
import { receiptDetailExamplesMarcopolo } from "./ReceiptDetailExamplesMarcopolo";

export const ReceiptDetailPanelMarcopolo = () => (
  <ReceiptDetailPanelVariant
    examples={receiptDetailExamplesMarcopolo}
    imageFolder="productImagesMarcopolo"
    badgeIcon={ecoSign}
    badgeAlt="Neu"
    badgeTitle="Neu"
  />
);
